<script setup lang="ts">
import {
  toRef,
} from 'vue';

import VFormInputWrapper
  from '@modules/forms/components/inputs/VFormInputWrapper/VFormInputWrapper.vue';

import type {
  VFormHiddenInputProps,
} from './types';
import { useInputInnerValue } from '../composables';

const props = withDefaults(defineProps<VFormHiddenInputProps>(), {});

const { innerValue } = useInputInnerValue(toRef(props, 'value'));
</script>

<template>
  <VFormInputWrapper v-data-qa-auto-id="'VFormHiddenInput'"
    :errors="errors"
    :hide-errors="hideErrors"
    :readonly="readonly"
    :class="isFullWidth ? 'w-full' : 'input-max-width'"
    class="flex items-center gap-4"
  >
    <div class="flex items-center gap-2 text-muted-color">
      <i
        v-if="icon"
        class="pi"
        :class="icon"
      />
      <div v-if="label">
        {{ label }}
      </div>
      <input
        type="hidden"
        :name="name"
        :value="innerValue"
      >
    </div>
  </VFormInputWrapper>
</template>
